import { NgClass } from "@angular/common";
import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { delayHelper } from "@commonHelpers/delay-helper";
import { isNullish } from "@commonHelpers/math-utils";
import { CatalogDetailsType } from "@enums/catalog-details-type";
import { ViewType } from "@enums/view-type";
import { ViewGroupItemDto, Viewer } from "@interfaces/HttpClient/CatalogApiPublicModels";
import { ICatalogRoutingParams } from "@interfaces/iCatalogRoutingParams";

@Component({
    selector: "app-attachment-thumbnails",
    templateUrl: "./attachment-thumbnails.component.html",
    styleUrls: ["./attachment-thumbnails.component.scss"],
    imports: [RouterLink, NgClass]
})
export class AttachmentThumbnailsComponent implements OnInit {
	@Input() routingParams: ICatalogRoutingParams;
	@Input() viewGroupItems: ViewGroupItemDto[];
	@Input() isEmbeded = false;
	@Input() currentViewType: ViewType
	@Input() catalogDetailsType: CatalogDetailsType
	public viewType = ViewType

	public Viewer = Viewer;

	constructor(private elRef: ElementRef) { }

	ngOnInit() {
		delayHelper(() => {
			// Anmerkung:  Berechnung der Scrollposition statt nutzen von scrollIntoView({inline: 'center'}), weil innerhalb iframes es zu unerwünschten scrollverhalten kommt
			const selectedItem = this.elRef.nativeElement.querySelector('#attachment-item-link-' + this.routingParams?.attachmentId);
			const container = this.elRef.nativeElement.querySelector('.scrollbox-autohover');
			if (!isNullish(selectedItem) && !isNullish(container)) {
				const scrollLeft = selectedItem.offsetLeft
					- container.offsetLeft
					- (container.clientWidth / 2)
					+ (selectedItem.clientWidth / 2);

				container.scrollLeft = scrollLeft;
			}
		})
	}

	public get selectedItem(): ViewGroupItemDto {
		if (this.routingParams?.attachmentId) {
			return this.viewGroupItems.find(item => item.id === +this.routingParams?.attachmentId);
		}

		return this.viewGroupItems.find(item => item !== undefined);
	}


	getRouterLink(item: ViewGroupItemDto) {
		const viewSegment = this.routingParams.view ? "/" + this.routingParams.view : ""
		return `${this.getModeSegment()}/catalogItem/${this.routingParams.catalogItemGuid}/attachment/${item.id}${viewSegment}`
	}

	private getModeSegment() {
		switch (this.catalogDetailsType) {
			case CatalogDetailsType.WatchlistDefault: return `/watchlist/${this.routingParams.watchlistSection}`;
			case CatalogDetailsType.Public: return `/catalog/${this.routingParams.key}`;
			case CatalogDetailsType.Preview: return `/preview/${this.routingParams.key}`;
			case CatalogDetailsType.WatchlistUserdefined: return `/watchlist/${this.routingParams.watchlistSection}/${this.routingParams.userDefined}`
		}
	}
}
